<template>
  <div class="ao__media ao__media--iframe">
    <iframe
      ref="root"
      class="w-full"
      :src="payload.attributes.src"
      :height="getHeight()"
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
const {payload} = defineProps<{
  payload?: any
}>()

const root = ref(null)

const getHeight = () => {
  if (payload.attributes.height) {
    return payload.attributes.height
  }
  if (!root.value) {
    return
  }

  return Math.round(root.value.offsetWidth / 16 * 10)
}

</script>

<style lang="postcss" scoped>
</style>
